import React from 'react'
import { BASE_URL, ICONS } from '../../constants'

import SiteSwitcher from './SiteSwitcher'

import styles from './BaseLayout.module.css'

const BaseLayout = ({ title, children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img
          src={`${BASE_URL}${ICONS.DIR}hcglogo.png`}
          alt="Horry County Logo"
          className={styles.logo}
        />
        <h1 className={styles.headerTitle}>
          <a
            href="https://www.horrycountysc.gov"
            className={styles.headerTitleLink}
          >
            horrycountysc<small>.gov</small>
          </a>{' '}
          - {title}
        </h1>
        <SiteSwitcher />
      </div>
      {children}
    </div>
  )
}

export default BaseLayout
